import React from "react";

const LogoWhite = (props) => (
	<svg
		x="0"
		y="0"
		width="99"
		height="5.29648130057325"
		className={props.className + " image-svg-svg primary"}
		style={{ overflow: "visible" }}
		xmlns="http://www.w3.org/2000/svg"
		viewBox="500.00011817641643574461 500.04781933128833771 400.13011169433594 250.12530517578125"
	>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M397.877106,694.088379 
	C397.877106,694.088379 397.891754,694.288452 397.898315,694.981750 
	C398.398071,696.913513 398.920990,698.578369 401.492157,696.895142 
	C402.267578,696.387512 403.635986,696.233276 404.517426,696.538635 
	C407.775848,697.667603 409.225708,696.670715 409.811737,692.991638 
	C412.885101,692.699890 415.958496,692.408203 419.375000,692.551636 
	C420.269653,692.284851 421.164307,692.018127 422.845581,691.391724 
	C424.570099,691.284546 426.294586,691.177368 428.270844,691.465698 
	C428.865906,691.251099 429.460968,691.036499 430.875671,690.464050 
	C435.590637,690.001465 440.305573,689.538940 445.273132,689.472839 
	C445.867249,689.252991 446.461395,689.033081 447.839478,688.440857 
	C449.569031,688.328857 451.298553,688.216919 453.276825,688.490601 
	C453.868774,688.289612 454.460754,688.088684 455.863159,687.537659 
	C457.917053,687.388550 459.970917,687.239441 462.371307,687.535706 
	C463.266663,687.250366 464.162018,686.965027 465.835327,686.354248 
	C467.233215,686.272278 468.631134,686.190247 470.277008,686.492065 
	C470.868744,686.296204 471.460449,686.100281 472.861145,685.550781 
	C474.915649,685.397217 476.970184,685.243652 479.519501,685.588745 
	C485.434906,685.169189 486.109039,684.051941 483.911865,677.284302 
	C484.001404,652.528870 484.090942,627.773499 484.934174,603.252197 
	C485.293793,604.944641 485.960144,606.635986 485.966217,608.329712 
	C486.038757,628.612732 485.993500,648.896118 486.035431,669.179260 
	C486.041504,672.120361 487.005585,675.217407 486.356323,677.965942 
	C485.300507,682.435730 487.150604,683.324341 491.748413,683.301941 
	C494.168243,683.210754 496.588043,683.119507 499.261169,683.438538 
	C499.855865,683.206299 500.450531,682.974060 501.839661,682.394714 
	C503.567627,682.290710 505.295624,682.186707 507.363159,682.508362 
	C507.926880,682.276733 508.490601,682.045044 509.746613,681.457336 
	C510.261688,681.442627 510.776733,681.427917 510.969482,682.128967 
	C511.483459,683.065186 511.997437,684.001404 512.511475,684.937622 
	C513.135864,683.677063 513.760254,682.416443 514.814453,680.987915 
	C514.814453,680.987915 515.256531,681.120361 515.786804,681.554199 
	C516.539185,681.307068 517.291504,681.059875 518.868530,680.460632 
	C523.916443,679.988281 528.964417,679.515930 534.262085,679.447693 
	C534.856812,679.232361 535.451538,679.017090 536.825989,678.414429 
	C538.559509,678.307312 540.293030,678.200195 542.449524,678.567505 
	C543.646240,678.206909 544.843018,677.846375 546.837158,677.225769 
	C548.228149,677.162292 549.619080,677.098816 551.264282,677.442017 
	C551.858948,677.213684 552.453552,676.985352 553.828369,676.375977 
	C555.556641,676.266052 557.284851,676.156189 559.261597,676.445618 
	C559.856140,676.241516 560.450684,676.037354 561.869080,675.455383 
	C567.167297,674.596680 572.465576,673.737976 578.501465,673.188660 
	C581.010010,672.971619 583.518555,672.754639 586.914062,672.392212 
	C589.614014,672.286316 592.313965,672.180420 595.103149,672.773926 
	C596.045166,673.420471 596.987183,674.067078 597.929199,674.713684 
	C598.294556,673.567322 598.659973,672.420898 599.748474,671.043457 
	C600.502014,671.039856 601.255615,671.036255 602.262268,671.436584 
	C602.857300,671.218689 603.452332,671.000854 604.826294,670.396790 
	C606.556824,670.285461 608.287415,670.174133 610.266296,670.456055 
	C610.859131,670.258118 611.452026,670.060242 612.829346,669.484314 
	C614.562317,669.356140 616.295288,669.227966 618.277466,669.483582 
	C618.866333,669.288208 619.455200,669.092896 620.863220,668.537781 
	C623.245117,668.369080 625.627014,668.200378 628.263672,668.437927 
	C628.857910,668.210876 629.452087,667.983887 630.833435,667.390015 
	C632.564087,667.289795 634.294739,667.189636 636.277710,667.477417 
	C636.867065,667.270691 637.456360,667.063965 638.845886,666.483521 
	C640.900574,666.334412 642.955261,666.185303 645.260498,666.437012 
	C645.855469,666.230713 646.450378,666.024353 647.828857,665.441528 
	C649.560242,665.321777 651.291687,665.202087 653.273254,665.470154 
	C653.863342,665.272522 654.453369,665.074890 655.859863,664.509338 
	C658.242615,664.349487 660.625305,664.189636 663.261108,664.437317 
	C663.856140,664.214844 664.451172,663.992310 665.826172,663.389221 
	C667.553284,663.268311 669.280334,663.147400 671.264648,663.430176 
	C671.858521,663.206055 672.452332,662.981934 673.730835,662.392761 
	C674.488159,662.231995 675.245422,662.071167 676.830566,662.041687 
	C679.214905,661.695374 681.599243,661.349060 684.505554,660.782043 
	C685.007751,660.520325 685.509949,660.258606 686.455261,660.506165 
	C687.962830,660.340393 689.470459,660.174561 691.837891,660.217346 
	C693.893982,660.152283 695.950134,660.087219 698.434570,660.584961 
	C699.924194,661.275391 701.413879,661.965759 702.903442,662.656128 
	C703.133972,661.507080 703.364441,660.358093 704.344910,658.977539 
	C715.898987,657.660400 727.453003,656.343323 739.313477,655.683899 
	C740.729004,656.402161 742.144531,657.120422 743.560059,657.838684 
	C744.045288,656.613525 744.530518,655.388367 745.663818,653.956970 
	C746.112793,653.983643 746.561707,654.010315 747.264343,654.438843 
	C747.858643,654.224304 748.452881,654.009766 749.846252,653.408752 
	C752.146790,653.119446 754.446838,652.589966 756.748047,652.584534 
	C764.632874,652.565979 770.057434,648.799744 774.305847,642.343262 
	C778.943542,635.295288 784.140137,628.616211 789.058533,621.751648 
	C794.394836,614.303955 800.858154,608.379150 810.310791,606.576660 
	C810.953247,606.893005 811.595764,607.209290 812.238220,607.525635 
	C812.491760,606.680420 812.745361,605.835266 813.400818,604.697876 
	C813.400818,604.697876 813.897522,604.688232 814.219421,605.243958 
	C814.926453,605.342407 815.633545,605.440857 816.340576,605.539307 
	C816.214844,605.021118 816.089111,604.502930 816.276062,603.100525 
	C816.339600,579.325439 816.419128,555.550293 816.407227,531.775208 
	C816.406799,530.839355 815.533386,529.903870 815.078247,528.383362 
	C815.608582,527.152954 816.138916,525.922485 816.604614,524.841980 
	C815.130554,524.424255 814.013916,524.107849 813.239563,523.086792 
	C814.541504,522.116821 816.954651,521.170898 816.976257,520.173340 
	C817.237183,508.097321 817.145386,496.013672 817.145386,483.665894 
	C806.949768,482.248993 797.256409,480.905731 787.564331,479.554199 
	C755.467224,475.078461 723.370544,470.599731 690.380981,466.048218 
	C686.124329,465.320770 685.958984,467.889923 685.969666,471.112854 
	C686.048706,494.911835 686.053894,518.711365 685.933472,542.510010 
	C685.923767,544.426147 684.800415,546.336670 684.045959,547.406494 
	C684.022949,519.962341 683.999939,492.518188 683.819824,464.574738 
	C683.230652,464.571381 682.641541,464.567993 681.547058,464.925262 
	C681.372131,465.035675 681.197144,465.146088 680.457825,465.170258 
	C679.946777,465.378693 679.435791,465.587097 678.105164,465.764984 
	C675.089233,466.570435 672.073303,467.375885 668.342285,468.156860 
	C667.910767,468.339661 667.479187,468.522461 666.524597,468.592865 
	C666.033875,468.787109 665.543152,468.981384 664.340515,469.143311 
	C663.909607,469.321930 663.478638,469.500519 662.521484,469.569977 
	C662.028320,469.765167 661.535095,469.960388 660.333252,470.124725 
	C659.903931,470.303131 659.474670,470.481537 658.517395,470.558777 
	C658.025696,470.758545 657.534058,470.958313 656.260193,471.142029 
	C654.520935,471.665680 652.781738,472.189331 650.518921,472.605530 
	C650.029053,472.795410 649.539124,472.985321 648.334290,473.155182 
	C647.903320,473.339935 647.472412,473.524689 646.519348,473.588470 
	C646.029053,473.782013 645.538696,473.975525 644.402039,474.128937 
	C643.602173,474.426514 642.802307,474.724060 641.175720,474.965637 
	C637.119324,475.995941 633.062988,477.026276 628.367798,478.009003 
	C627.574280,478.280884 626.780762,478.552765 625.446777,478.754211 
	C625.296997,478.857147 625.147278,478.960052 624.346619,479.021057 
	C623.535461,479.284393 622.724365,479.547729 621.412048,479.724915 
	C621.276306,479.826416 621.140564,479.927917 620.229309,480.009308 
	C619.505798,480.255676 618.782227,480.502045 617.363525,480.670074 
	C615.590881,481.165985 613.818237,481.661896 611.259216,482.142639 
	C607.822998,483.047577 604.386719,483.952545 600.106934,484.798828 
	C596.545654,485.597321 593.015686,486.608246 589.414917,487.138824 
	C585.209412,487.758545 583.573547,489.758453 584.154785,494.056549 
	C584.505127,496.647125 584.057556,499.345642 583.193359,501.798035 
	C582.790466,499.670868 582.006348,497.531921 582.071594,495.419220 
	C582.176880,492.008484 581.095154,490.437592 577.014648,490.828064 
	C576.546936,490.744080 576.040833,490.498444 575.617004,490.599182 
	C549.544312,496.792816 523.500061,503.109070 497.390106,509.140686 
	C493.084198,510.135345 491.662750,511.760193 491.701691,516.344971 
	C491.908234,540.653137 491.688507,564.964905 491.094025,590.022522 
	C491.034210,592.672729 490.974396,595.322876 490.852020,598.773621 
	C490.788452,599.837463 490.724884,600.901367 490.061401,601.808899 
	C488.106812,601.533386 486.152252,601.257874 483.830139,600.195740 
	C478.584473,600.981140 473.338776,601.766479 468.106567,601.674255 
	C468.370270,599.649902 468.633942,597.625549 469.502777,595.071899 
	C469.674164,588.281799 469.934357,581.492493 469.995453,574.701416 
	C470.080627,565.235962 470.016937,555.769165 470.016937,546.241699 
	C468.561035,545.956665 467.607483,545.720276 466.639679,545.587646 
	C418.942291,539.047546 371.237946,532.557495 323.551727,525.936890 
	C316.906921,525.014404 310.533325,524.724548 303.834503,526.370728 
	C278.603729,532.571045 253.251999,538.278503 227.950073,544.189819 
	C215.985489,546.985107 204.031128,549.824036 191.921738,552.678650 
	C191.921738,557.717529 192.127640,562.380493 191.852631,567.015015 
	C191.654419,570.355530 193.155472,571.332153 196.120682,571.661804 
	C201.682709,572.280212 207.215118,573.164917 212.655548,573.924377 
	C212.655548,596.883545 212.655548,619.324097 212.655548,641.840698 
	C210.012939,642.530334 207.597107,643.140747 205.192459,643.792480 
	C200.431290,645.082764 193.875900,644.978333 191.421661,648.095398 
	C188.933655,651.255493 190.366669,657.606812 190.319412,662.562622 
	C190.224594,672.509827 190.291229,682.458557 190.291229,692.827515 
	C193.509979,692.299500 195.943405,691.962158 198.351913,691.495972 
	C230.878265,685.199097 263.395386,678.854248 295.928253,672.591309 
	C306.722046,670.513306 316.058136,673.265259 323.538025,681.540649 
	C326.442017,684.753540 329.499084,687.856628 332.123718,691.287231 
	C337.200439,697.922791 343.578430,701.255310 352.280640,700.488953 
	C352.872375,700.265015 353.464142,700.041077 354.843536,699.456055 
	C356.569824,699.331970 358.296112,699.207825 360.273468,699.478699 
	C360.867493,699.261475 361.461548,699.044189 362.841431,698.459290 
	C364.569489,698.338074 366.297577,698.216858 368.272614,698.486755 
	C368.866241,698.280762 369.459839,698.074707 370.865479,697.524292 
	C372.917725,697.377686 374.969940,697.231018 377.271301,697.478394 
	C377.865356,697.268005 378.459381,697.057678 379.863190,696.471069 
	C383.238403,695.976013 386.613617,695.481018 390.407562,694.924561 
	C390.407562,691.315369 390.407562,688.179871 391.103790,685.034729 
	C393.158875,684.047729 395.213959,683.060791 397.518066,682.784302 
	C397.389984,683.503479 397.261902,684.222717 396.686157,685.066528 
	C396.836761,685.731445 396.987396,686.396362 397.509369,687.770203 
	C397.433685,688.824036 397.358002,689.877930 396.705566,690.987000 
	C394.747589,692.395935 394.884521,692.836548 397.877106,694.088379 
z"/>
		<path fill="#032F63" opacity="1.000000" stroke="none"
			d="
M1025.365845,685.283997 
	C991.460571,730.535461 966.936951,779.809692 960.491150,837.614624 
	C958.384277,836.787476 956.603699,836.143188 954.866272,835.398254 
	C927.355347,823.603027 900.146484,811.035156 872.278931,800.154236 
	C820.527527,779.947998 767.113159,776.666565 712.536255,786.247131 
	C683.184204,791.399658 655.125549,800.676086 627.118652,810.366516 
	C603.822083,818.427185 580.356445,825.800415 555.791687,829.131775 
	C523.946411,833.450439 492.598724,830.820740 461.724884,822.456665 
	C439.088074,816.324097 416.714264,809.216492 394.059021,803.157410 
	C354.658691,792.619812 315.289154,793.848267 276.002869,804.349609 
	C256.070404,809.677612 235.962341,814.346436 216.004333,819.582642 
	C209.834045,821.201416 205.939957,819.779358 201.641495,814.672668 
	C179.027634,787.806458 164.271057,757.415588 158.330704,722.769531 
	C157.049133,715.294983 157.657776,714.088623 165.057556,712.608093 
	C207.696625,704.077087 250.362350,695.678650 292.987885,687.080933 
	C302.417877,685.178955 310.080017,687.486938 316.173309,694.958557 
	C318.594879,697.927795 321.187347,700.762268 323.525146,703.794434 
	C330.287384,712.564941 339.344543,715.653870 350.019470,714.429199 
	C383.790680,710.554443 417.546326,706.544189 451.314423,702.642151 
	C513.715515,695.431335 576.114746,688.203125 638.527222,681.092468 
	C680.241577,676.339966 721.980347,671.803040 763.701416,667.109009 
	C771.849304,666.192322 778.318420,662.724243 783.118103,655.564026 
	C788.950745,646.862610 795.625427,638.721863 802.008301,630.394104 
	C807.544983,623.170349 815.391113,619.486267 823.801392,617.057800 
	C884.435791,599.549561 945.284790,582.899780 1007.991577,574.372070 
	C1037.741089,570.326355 1067.623779,567.720032 1097.691040,569.039062 
	C1103.952393,569.313721 1110.303711,570.331543 1116.348877,571.978516 
	C1122.879395,573.757874 1124.820801,578.563538 1122.161133,584.846680 
	C1120.813477,588.029846 1118.892090,591.030762 1116.874634,593.860657 
	C1079.645264,646.079468 1043.740601,699.187927 1011.619873,754.719360 
	C999.387573,775.866699 988.929382,798.040161 977.656311,819.742676 
	C977.360901,820.311340 976.990479,820.841003 976.557190,821.548767 
	C974.554810,803.260193 1000.618896,732.595886 1026.429932,686.401367 
	C1026.727173,685.315369 1026.695679,684.748657 1026.664185,684.181946 
	C1026.231445,684.549316 1025.798584,684.916626 1025.365845,685.283997 
M955.813477,640.214661 
	C953.485718,641.038330 950.951660,641.514404 948.869019,642.750916 
	C942.664368,646.434570 940.164246,652.212036 940.965088,659.236633 
	C941.737183,666.009766 945.825806,670.539917 952.155518,672.549011 
	C958.661072,674.613953 964.773621,673.266785 969.428833,668.028503 
	C974.023193,662.858704 974.993286,656.757690 972.274902,650.392090 
	C969.382568,643.619446 964.020020,640.250854 955.813477,640.214661 
z"/>
		<path fill="#053064" opacity="1.000000" stroke="none"
			d="
M245.001144,866.184448 
	C199.523727,865.888306 159.008224,851.897949 122.307907,826.096313 
	C129.997757,827.734314 137.647003,829.601685 145.384308,830.971619 
	C184.052231,837.818176 222.295746,834.673462 260.532532,826.841614 
	C281.528503,822.541199 302.795685,818.917114 324.121277,817.029785 
	C353.933380,814.391418 382.630646,821.590454 410.980255,830.303894 
	C433.540527,837.238098 456.070648,844.580444 479.065125,849.726562 
	C525.765076,860.178040 572.041870,856.690857 617.665100,842.428101 
	C645.608337,833.692627 673.447205,824.398438 701.822571,817.317444 
	C757.562317,803.407715 812.605896,808.301758 866.474121,827.402222 
	C893.432495,836.961060 920.001404,847.622192 946.988464,857.095276 
	C989.572876,872.043579 1033.209839,878.399048 1078.235840,871.102661 
	C1079.027222,870.974365 1079.840088,870.977661 1081.664062,870.845703 
	C1080.026855,872.021790 1079.203369,872.722595 1078.283691,873.258240 
	C1036.556763,897.557983 991.840210,909.221558 943.402527,905.130371 
	C914.640564,902.701050 887.077454,895.157349 859.946106,885.695984 
	C828.533325,874.741516 797.344543,863.171387 764.741699,855.879272 
	C727.079956,847.455627 689.533325,848.487671 652.184204,856.584412 
	C618.524475,863.881409 585.216858,872.788208 551.621277,880.399536 
	C516.077942,888.452209 480.172607,893.278992 443.552917,890.147400 
	C421.643341,888.273865 400.485504,882.916077 379.872711,875.797241 
	C342.986206,863.058044 305.379303,860.676392 266.961975,865.355225 
	C259.879608,866.217712 252.658096,865.937927 245.001144,866.184448 
z"/>
		<path fill="#042F63" opacity="1.000000" stroke="none"
			d="
M360.022400,699.083679 
	C358.296112,699.207825 356.569824,699.331970 354.196167,699.536621 
	C353.041351,699.777283 352.533936,699.937500 352.026489,700.097656 
	C343.578430,701.255310 337.200439,697.922791 332.123718,691.287231 
	C329.499084,687.856628 326.442017,684.753540 323.538025,681.540649 
	C316.058136,673.265259 306.722046,670.513306 295.928253,672.591309 
	C263.395386,678.854248 230.878265,685.199097 198.351913,691.495972 
	C195.943405,691.962158 193.509979,692.299500 190.291229,692.827515 
	C190.291229,682.458557 190.224594,672.509827 190.319412,662.562622 
	C190.366669,657.606812 188.933655,651.255493 191.421661,648.095398 
	C193.875900,644.978333 200.431290,645.082764 205.192459,643.792480 
	C207.597107,643.140747 210.012939,642.530334 212.655548,641.840698 
	C212.655548,619.324097 212.655548,596.883545 212.655548,573.924377 
	C207.215118,573.164917 201.682709,572.280212 196.120682,571.661804 
	C193.155472,571.332153 191.654419,570.355530 191.852631,567.015015 
	C192.127640,562.380493 191.921738,557.717529 191.921738,552.678650 
	C204.031128,549.824036 215.985489,546.985107 227.950073,544.189819 
	C253.251999,538.278503 278.603729,532.571045 303.834503,526.370728 
	C310.533325,524.724548 316.906921,525.014404 323.551727,525.936890 
	C371.237946,532.557495 418.942291,539.047546 466.639679,545.587646 
	C467.607483,545.720276 468.561035,545.956665 470.016937,546.241699 
	C470.016937,555.769165 470.080627,565.235962 469.995453,574.701416 
	C469.934357,581.492493 469.674164,588.281799 468.855103,595.286255 
	C467.089264,595.777954 465.971069,596.055298 464.457886,596.348389 
	C463.042725,596.621338 462.022552,596.878540 460.764038,597.080322 
	C460.169861,597.018860 459.887634,597.159973 459.662933,597.459900 
	C459.646820,597.471436 459.606842,597.469666 459.191956,597.473022 
	C454.728516,598.305481 450.668152,599.081238 446.633423,599.972961 
	C428.742218,603.927246 410.858337,607.914673 392.531830,611.875061 
	C391.448517,612.949524 390.288910,614.021912 390.251953,615.131653 
	C390.098419,619.738037 390.283722,624.355713 390.237793,629.428467 
	C390.214539,636.272400 390.298126,642.657104 390.299469,649.500977 
	C390.268188,657.296265 390.319153,664.632385 390.262817,672.423218 
	C390.239563,676.933350 390.323578,680.988831 390.407562,685.044312 
	C390.407562,688.179871 390.407562,691.315369 390.407562,694.924561 
	C386.613617,695.481018 383.238403,695.976013 379.206238,696.558105 
	C378.040283,696.791565 377.531219,696.937927 377.022186,697.084351 
	C374.969940,697.231018 372.917725,697.377686 370.209778,697.588379 
	C369.044586,697.800171 368.535095,697.947876 368.025635,698.095642 
	C366.297577,698.216858 364.569489,698.338074 362.195801,698.539062 
	C361.040924,698.773804 360.531677,698.928772 360.022400,699.083679 
M381.629425,566.642822 
	C381.629425,564.556763 381.629425,562.470642 381.629425,560.162170 
	C377.018402,559.629395 373.028778,559.168457 368.927856,558.694641 
	C368.927856,564.755493 368.927856,570.160095 368.927856,575.851196 
	C373.131348,576.423401 377.125458,576.967163 381.625946,577.579834 
	C381.625946,573.799255 381.625946,570.689514 381.629425,566.642822 
M333.079895,568.171448 
	C332.891266,570.347046 333.055542,572.059204 335.997742,572.176819 
	C339.231873,572.306152 342.448608,572.871338 345.876343,573.270325 
	C345.876343,567.099182 345.876343,561.537292 345.876343,555.684326 
	C341.601196,555.179810 337.583557,554.705627 333.078857,554.174011 
	C333.078857,558.966858 333.078857,563.106445 333.079895,568.171448 
M410.132080,581.086121 
	C411.894165,581.320435 413.656250,581.554749 415.709717,581.827881 
	C415.709717,575.982361 415.709717,570.553223 415.709717,564.677368 
	C411.603729,564.110046 407.547577,563.549622 403.168976,562.944641 
	C403.168976,568.886414 403.168976,574.460876 403.168976,580.401489 
	C405.333984,580.614136 407.292786,580.806519 410.132080,581.086121 
M449.853394,578.393188 
	C449.853394,575.289673 449.853394,572.186157 449.853394,568.896851 
	C445.443390,568.275879 441.534821,567.725525 437.337097,567.134460 
	C437.337097,572.872437 437.337097,578.294861 437.337097,584.076843 
	C441.508881,584.552856 445.527252,585.011414 449.851166,585.504761 
	C449.851166,582.937988 449.851166,581.126038 449.853394,578.393188 
M238.131729,621.858887 
	C238.131729,626.267822 238.131729,630.676758 238.131729,635.582397 
	C242.415115,634.672302 246.101517,633.888977 249.822845,633.098267 
	C249.822845,626.997253 249.822845,621.248840 249.822845,615.204590 
	C246.613068,615.887634 243.595963,616.207947 240.860077,617.259827 
	C239.657806,617.722046 239.028427,619.674316 238.131729,621.858887 
M238.500931,591.601807 
	C242.332596,590.908508 246.164261,590.215271 249.766922,589.563416 
	C249.766922,583.319763 249.766922,577.758301 249.766922,571.892578 
	C245.724396,572.847107 242.056335,573.713257 238.167511,574.631531 
	C238.167511,580.223022 238.167511,585.507874 238.500931,591.601807 
M284.201630,619.385132 
	C284.201630,615.643921 284.201630,611.902771 284.201630,607.814819 
	C280.087860,608.749939 276.598816,609.543030 272.953125,610.371704 
	C272.953125,616.343018 272.953125,622.042236 272.953125,628.252441 
	C276.904358,627.359253 280.490295,626.548645 284.204834,625.708923 
	C284.204834,623.609924 284.204834,621.971191 284.201630,619.385132 
M282.855316,582.080139 
	C283.497894,576.227295 284.140503,570.374451 284.839020,564.012268 
	C280.834686,564.837769 278.002167,565.197571 275.342712,566.079285 
	C274.264984,566.436584 272.865570,567.894409 272.811066,568.915405 
	C272.547729,573.848022 272.692413,578.802429 272.692413,584.294556 
	C276.235199,583.539856 279.120667,582.925232 282.855316,582.080139 
z"/>
		<path fill="#042F63" opacity="1.000000" stroke="none"
			d="
M698.006226,660.022156 
	C695.950134,660.087219 693.893982,660.152283 691.423462,659.730591 
	C690.931335,658.489197 690.853699,657.734558 690.860840,656.519409 
	C690.867676,638.267273 690.789734,620.475647 690.825317,602.259216 
	C690.871460,597.215393 690.804138,592.596436 690.823853,587.555908 
	C690.859680,579.314331 690.808533,571.494141 690.874634,563.323059 
	C691.300476,560.464294 691.609070,557.956543 692.120850,555.489502 
	C692.620911,555.498535 692.851440,555.357971 693.426880,555.150452 
	C719.823242,549.618042 745.813538,544.067261 771.791687,538.460449 
	C786.227112,535.344788 800.642334,532.135376 815.066711,528.968201 
	C815.533386,529.903870 816.406799,530.839355 816.407227,531.775208 
	C816.419128,555.550293 816.339600,579.325439 815.833374,603.543640 
	C814.892944,604.220581 814.395264,604.454407 813.897522,604.688232 
	C813.897522,604.688232 813.400818,604.697876 812.872803,604.815063 
	C811.563904,605.290894 810.783020,605.649597 810.002197,606.008301 
	C800.858154,608.379150 794.394836,614.303955 789.058533,621.751648 
	C784.140137,628.616211 778.943542,635.295288 774.305847,642.343262 
	C770.057434,648.799744 764.632874,652.565979 756.748047,652.584534 
	C754.446838,652.589966 752.146790,653.119446 749.194702,653.501465 
	C748.032288,653.741760 747.521484,653.889404 747.010681,654.036987 
	C746.561707,654.010315 746.112793,653.983643 744.953247,653.998474 
	C742.497498,654.368713 740.752258,654.697449 739.007080,655.026184 
	C727.453003,656.343323 715.898987,657.660400 703.664917,659.023926 
	C701.325378,659.387512 699.665833,659.704834 698.006226,660.022156 
z"/>
		<path fill="#073164" opacity="1.000000" stroke="none"
			d="
M331.021576,517.911133 
	C314.558777,512.650940 299.382874,518.014038 284.051758,521.575989 
	C274.199554,523.864990 264.323517,526.051453 253.720337,528.450806 
	C253.720337,524.607239 253.725952,521.186035 253.719299,517.764893 
	C253.697952,506.774109 253.547028,495.781281 253.725235,484.793762 
	C253.777756,481.555450 252.645813,480.444153 249.575424,480.131470 
	C244.781097,479.643188 239.974686,478.981689 235.290405,477.891022 
	C233.968353,477.583252 232.234085,475.601532 232.104828,474.251984 
	C231.694656,469.969299 231.953140,465.622620 231.953140,460.929047 
	C242.630707,458.346069 253.243591,455.751587 263.870972,453.217804 
	C270.505951,451.635925 277.272430,450.506683 283.783508,448.528046 
	C293.105774,445.695068 302.144897,446.091766 311.738342,447.664612 
	C361.169220,455.768616 410.699677,463.265381 460.194214,470.981354 
	C461.986725,471.260773 463.767456,471.615814 465.366180,471.902039 
	C465.636993,472.517426 465.870422,472.810211 465.884003,473.112885 
	C466.522644,487.340912 466.563568,487.534729 452.729950,490.612701 
	C448.617798,491.527649 447.478638,493.154663 447.574188,497.237183 
	C447.858002,509.362274 447.675873,521.498291 447.675873,534.340454 
	C408.493988,528.821838 369.974976,523.396606 331.021576,517.911133 
M319.948853,473.692261 
	C315.677856,473.004669 311.320404,472.646606 307.155579,471.554260 
	C300.474030,469.801849 294.475525,471.723602 288.005371,473.962158 
	C290.373322,481.976257 292.660126,489.715698 295.041962,497.776733 
	C301.116791,496.557434 307.339722,496.611053 311.817352,493.842224 
	C313.951813,492.522339 312.765167,485.835480 313.097290,481.580811 
	C313.108490,481.437256 313.276154,481.305939 313.658051,480.753448 
	C317.936707,481.426483 322.428192,482.133026 327.321320,482.902740 
	C327.321320,487.922546 327.321320,492.356812 327.321320,497.040375 
	C332.633392,497.809387 337.476746,498.510559 342.965942,499.305237 
	C342.965942,494.164276 342.965942,489.753479 342.965942,485.022705 
	C347.933563,485.814240 352.300568,486.510101 357.053925,487.267487 
	C357.053925,492.196625 357.053925,496.617004 357.053925,501.334991 
	C362.341187,502.088226 367.190186,502.779022 372.727478,503.567902 
	C372.727478,498.563293 372.727478,494.311005 372.727478,489.979584 
	C373.996246,490.077271 374.660339,490.103943 375.318207,490.182678 
	C385.827606,491.440857 385.745850,491.447754 386.428284,501.797089 
	C386.522675,503.228394 387.661560,505.543518 388.710114,505.792358 
	C392.981598,506.805969 397.406036,507.174927 402.477905,507.879181 
	C402.477905,502.945404 402.477905,498.731812 402.477905,494.107239 
	C407.370300,494.827637 411.572266,495.446381 416.267883,496.137787 
	C416.267883,500.911774 416.267883,505.318115 416.267883,509.890503 
	C421.214478,510.500580 425.628204,511.044952 430.737091,511.675049 
	C430.737091,505.592194 430.600433,499.970001 430.793274,494.359131 
	C430.893524,491.442139 430.006226,490.289795 426.970947,489.982117 
	C421.014618,489.378418 415.106232,488.295593 409.181427,487.388611 
	C379.724731,482.879150 350.269196,478.362396 319.948853,473.692261 
z"/>
		<path fill="#073064" opacity="1.000000" stroke="none"
			d="
M825.376282,907.782471 
	C819.716797,906.872253 814.023804,906.131958 808.403076,905.024902 
	C766.419861,896.756042 725.230347,901.097900 684.412231,912.459167 
	C650.854980,921.799500 617.175232,930.505310 582.043640,931.570496 
	C542.312927,932.775085 504.174957,925.484253 467.384369,910.681946 
	C466.837982,910.462158 466.347809,910.102478 464.962677,909.312744 
	C475.380768,909.312744 484.773895,909.568481 494.149170,909.267151 
	C529.144836,908.142578 563.210754,901.179138 597.021423,892.624451 
	C624.767273,885.604187 652.360657,877.789429 680.937683,874.707947 
	C730.022156,869.415100 775.950684,879.277771 818.760437,903.806396 
	C820.781677,904.964478 822.793091,906.139709 825.060486,907.556763 
	C825.311890,907.806519 825.376282,907.782471 825.376282,907.782471 
z"/>
		<path fill="#032F63" opacity="1.000000" stroke="none"
			d="
M602.009155,671.032593 
	C601.255615,671.036255 600.502014,671.039856 599.052979,671.089111 
	C597.905762,671.103882 597.454102,671.073120 596.723877,670.753662 
	C593.199036,670.464966 589.952698,670.464966 586.377441,670.464966 
	C586.254456,669.212463 586.019470,667.929016 586.018433,666.645447 
	C585.997131,639.197754 586.000183,611.750122 586.005981,584.302429 
	C586.006348,582.382812 586.065002,580.463135 586.474854,578.356323 
	C587.991333,577.937988 589.131226,577.715027 590.267395,577.474548 
	C617.842285,571.638550 645.416870,565.800476 673.244751,560.220825 
	C676.005432,559.713196 678.512939,558.947571 681.250488,558.077637 
	C681.648987,557.975281 681.817444,557.977234 682.002014,558.448792 
	C682.022522,588.789246 681.945007,618.660522 682.103943,648.530518 
	C682.133789,654.141052 682.351990,659.405884 676.002747,661.910339 
	C675.245422,662.071167 674.488159,662.231995 673.134521,662.477478 
	C672.027954,662.716980 671.517700,662.871765 671.007446,663.026489 
	C669.280334,663.147400 667.553284,663.268311 665.183350,663.475159 
	C664.029724,663.717285 663.518921,663.873474 663.008057,664.029785 
	C660.625305,664.189636 658.242615,664.349487 655.203613,664.588867 
	C654.039307,664.806396 653.531189,664.944397 653.023071,665.082397 
	C651.291687,665.202087 649.560242,665.321777 647.186401,665.526306 
	C646.032593,665.752747 645.521240,665.894470 645.009949,666.036194 
	C642.955261,666.185303 640.900574,666.334412 638.196411,666.567749 
	C637.039795,666.797852 636.532593,666.943665 636.025391,667.089478 
	C634.294739,667.189636 632.564087,667.289795 630.186768,667.467529 
	C629.029663,667.707275 628.519287,667.869446 628.008911,668.031677 
	C625.627014,668.200378 623.245117,668.369080 620.205444,668.616455 
	C619.041199,668.830078 618.534729,668.964966 618.028259,669.099854 
	C616.295288,669.227966 614.562317,669.356140 612.187866,669.571655 
	C611.036926,669.793579 610.527466,669.928223 610.017944,670.062866 
	C608.287415,670.174133 606.556824,670.285461 604.183594,670.491211 
	C603.030273,670.734558 602.519714,670.883606 602.009155,671.032593 
z"/>
		<path fill="#043064" opacity="1.000000" stroke="none"
			d="
M678.924744,465.795532 
	C679.435791,465.587097 679.946777,465.378693 680.927307,465.570251 
	C681.335022,473.543335 681.142395,481.118195 681.240784,488.689240 
	C681.408875,501.624664 681.806274,514.556946 682.016846,527.492004 
	C682.155273,535.992371 683.242188,544.724182 676.618774,552.082153 
	C654.199524,556.925354 632.145081,561.608154 609.848022,565.980591 
	C607.853149,565.706787 606.053528,565.497620 604.357117,565.824463 
	C598.400269,566.971863 592.479004,568.303833 586.220581,569.634583 
	C586.220581,542.776978 586.220581,516.340881 586.220581,489.816650 
	C588.239746,489.338074 590.229004,489.039734 592.093079,488.385162 
	C595.088989,487.333069 598.002319,486.045593 600.950500,484.857544 
	C604.386719,483.952545 607.822998,483.047577 611.918518,482.383667 
	C614.666809,482.764679 617.249695,484.347412 618.058716,480.748413 
	C618.782227,480.502045 619.505798,480.255676 620.721924,480.172729 
	C621.447388,480.161102 621.680298,479.986084 621.913208,479.811066 
	C622.724365,479.547729 623.535461,479.284393 624.787842,479.193146 
	C625.481750,479.185028 625.734497,479.004822 625.987244,478.824646 
	C626.780762,478.552765 627.574280,478.280884 628.954651,478.287537 
	C633.695129,477.384583 637.848816,476.203094 642.002441,475.021606 
	C642.802307,474.724060 643.602173,474.426514 644.866577,474.333832 
	C645.901184,474.262299 646.471313,473.985870 647.041443,473.709473 
	C647.472412,473.524689 647.903320,473.339935 648.833374,473.349792 
	C649.902527,473.267242 650.472473,472.990112 651.042480,472.713013 
	C652.781738,472.189331 654.520935,471.665680 656.796936,471.335541 
	C657.904236,471.239319 658.474792,470.949615 659.045349,470.659912 
	C659.474670,470.481537 659.903931,470.303131 660.831421,470.326111 
	C661.902344,470.244690 662.475037,469.961914 663.047729,469.679108 
	C663.478638,469.500519 663.909607,469.321930 664.838623,469.343323 
	C665.907043,469.264008 666.477356,468.984619 667.047668,468.705261 
	C667.479187,468.522461 667.910767,468.339661 668.980957,468.403809 
	C672.721313,467.699036 675.822998,466.747314 678.924744,465.795532 
z"/>
		<path fill="#042F62" opacity="1.000000" stroke="none"
			d="
M559.013123,676.046265 
	C557.284851,676.156189 555.556641,676.266052 553.184265,676.462830 
	C552.030090,676.711548 551.520081,676.873413 551.010071,677.035278 
	C549.619080,677.098816 548.228149,677.162292 546.098083,677.291016 
	C544.248169,677.601868 543.137390,677.847473 542.026550,678.093079 
	C540.293030,678.200195 538.559509,678.307312 536.184326,678.503784 
	C535.032593,678.743225 534.522461,678.893372 534.012329,679.043518 
	C528.964417,679.515930 523.916443,679.988281 518.182861,680.530762 
	C516.750244,680.774048 516.003357,680.947205 515.256531,681.120361 
	C515.256531,681.120361 514.814453,680.987915 514.292480,680.995972 
	C512.944275,681.140381 512.118042,681.276733 511.291809,681.413147 
	C510.776733,681.427917 510.261688,681.442627 509.210968,681.519287 
	C508.124756,681.748413 507.574158,681.915588 507.023590,682.082764 
	C505.295624,682.186707 503.567627,682.290710 501.189789,682.455750 
	C500.029236,682.687256 499.518555,682.857727 499.007874,683.028259 
	C496.588043,683.119507 494.168243,683.210754 491.342743,682.708496 
	C490.839539,678.401367 490.742035,674.687622 490.735718,670.515320 
	C490.759064,664.047607 490.691254,658.038513 490.740509,651.572266 
	C490.772644,642.733948 490.687744,634.352783 490.695129,625.545166 
	C490.733398,623.088989 490.679352,621.059143 490.742615,618.573181 
	C490.793762,612.733093 490.727539,607.349121 490.661346,601.965210 
	C490.724884,600.901367 490.788452,599.837463 491.278442,598.278687 
	C498.859161,596.309814 506.015900,594.847351 513.167419,593.359802 
	C533.160461,589.201172 553.144165,584.996094 573.160156,580.951111 
	C574.441406,580.692200 575.966614,581.640381 577.213196,582.448975 
	C577.149780,585.571167 577.251465,588.271362 577.395935,591.440430 
	C577.421082,595.056458 577.375000,598.203918 577.390503,601.351074 
	C577.508118,625.193787 577.637817,649.036560 577.763794,672.879272 
	C572.465576,673.737976 567.167297,674.596680 561.207275,675.537476 
	C560.034729,675.761841 559.523926,675.904053 559.013123,676.046265 
z"/>
		<path fill="#042F63" opacity="1.000000" stroke="none"
			d="
M691.273743,466.122131 
	C723.370544,470.599731 755.467224,475.078461 787.564331,479.554199 
	C797.256409,480.905731 806.949768,482.248993 817.145386,483.665894 
	C817.145386,496.013672 817.237183,508.097321 816.976257,520.173340 
	C816.954651,521.170898 814.541504,522.116821 812.626343,523.492249 
	C810.207153,523.999207 808.351990,523.868042 806.602600,524.237549 
	C784.360840,528.935669 762.130920,533.690125 739.904968,538.462769 
	C724.818115,541.702393 709.733215,544.952637 694.670959,548.304016 
	C692.381592,548.813416 690.749207,548.998108 690.866821,545.551025 
	C690.874756,543.089294 690.801758,541.057007 690.835083,538.628418 
	C690.874268,537.147461 690.807129,536.062622 690.828064,534.532837 
	C690.873718,531.065308 690.831299,528.042847 690.892578,524.565552 
	C690.905273,520.066040 690.814270,516.021301 690.810730,511.517883 
	C690.841003,505.714325 690.783752,500.369537 690.834351,494.567261 
	C690.872620,489.065491 690.803223,484.021210 690.824829,478.528381 
	C690.864502,474.727570 690.813171,471.375336 690.876221,467.714783 
	C691.085022,466.978363 691.179382,466.550262 691.273743,466.122131 
z"/>
		<path fill="#042F62" opacity="1.000000" stroke="none"
			d="
M491.616455,589.275452 
	C491.688507,564.964905 491.908234,540.653137 491.701691,516.344971 
	C491.662750,511.760193 493.084198,510.135345 497.390106,509.140686 
	C523.500061,503.109070 549.544312,496.792816 575.617004,490.599182 
	C576.040833,490.498444 576.546936,490.744080 577.174194,491.447693 
	C577.321289,493.562592 577.296204,495.057892 577.298218,496.553101 
	C577.330383,520.651123 577.373535,544.749084 577.387939,568.847107 
	C577.389282,571.052612 578.051086,573.267883 574.458923,573.981873 
	C548.072205,579.226624 521.736328,584.726624 495.364594,590.047913 
	C494.214050,590.280151 492.870239,589.554749 491.616455,589.275452 
z"/>
		<path fill="#042F63" opacity="1.000000" stroke="none"
			d="
M468.093109,602.551880 
	C473.338776,601.766479 478.584473,600.981140 483.891357,600.919556 
	C484.028503,602.101624 484.104492,602.559875 484.180481,603.018066 
	C484.090942,627.773499 484.001404,652.528870 483.867615,678.024292 
	C483.736908,680.493164 483.650513,682.222046 483.565491,683.923157 
	C481.823029,684.370972 480.423859,684.730530 479.024689,685.090149 
	C476.970184,685.243652 474.915649,685.397217 472.207275,685.627258 
	C471.045258,685.838562 470.537140,685.973450 470.029022,686.108276 
	C468.631134,686.190247 467.233215,686.272278 465.145691,686.410889 
	C463.645630,686.675171 462.835205,686.882751 462.024811,687.090332 
	C459.970917,687.239441 457.917053,687.388550 455.208038,687.612061 
	C454.044647,687.825928 453.536377,687.965393 453.028107,688.104980 
	C451.298553,688.216919 449.569031,688.328857 447.194489,688.524658 
	C446.039825,688.764404 445.530182,688.920349 445.020538,689.076294 
	C440.305573,689.538940 435.590637,690.001465 430.213379,690.537231 
	C429.040436,690.763672 428.529785,690.916931 428.019104,691.070190 
	C426.294586,691.177368 424.570099,691.284546 422.151489,691.477051 
	C420.648895,691.747070 419.840363,691.931824 419.031860,692.116516 
	C415.958496,692.408203 412.885101,692.699890 408.994690,693.047974 
	C404.749023,693.499023 401.320374,693.893738 397.891754,694.288452 
	C397.891754,694.288452 397.877106,694.088379 397.753571,693.698364 
	C397.514130,692.516174 397.398224,691.723938 397.282349,690.931763 
	C397.358002,689.877930 397.433685,688.824036 397.533386,687.082214 
	C397.416229,685.910095 397.275024,685.426025 397.133850,684.941895 
	C397.261902,684.222717 397.389984,683.503479 397.544250,681.978699 
	C397.461823,676.105347 397.353180,671.037598 397.370697,665.519287 
	C397.408783,658.069885 397.320740,651.071106 397.385986,643.623901 
	C397.428009,638.440430 397.316681,633.705505 397.330017,628.531067 
	C397.689972,624.501221 397.925323,620.910889 398.581238,617.308594 
	C418.645111,613.083069 438.288452,608.869446 458.265594,604.667847 
	C460.736267,604.141052 462.873108,603.602173 465.325806,603.120728 
	C466.458801,602.969360 467.275970,602.760620 468.093109,602.551880 
z"/>
		<path fill="#073164" opacity="1.000000" stroke="none"
			d="
M374.583435,417.321869 
	C376.411194,428.745483 378.150879,439.743683 380.034943,451.654663 
	C364.386810,449.186646 349.221313,446.794769 333.753784,444.355255 
	C335.848480,421.120850 337.893677,398.435638 339.978149,375.314880 
	C330.912384,373.803711 322.271332,372.200165 313.575012,370.995605 
	C310.188934,370.526642 308.923828,369.042419 309.043091,365.807281 
	C309.141174,363.146912 308.946716,360.476440 309.021820,357.814392 
	C309.129883,353.984192 310.923187,352.519440 314.875427,353.361877 
	C323.473145,355.194458 332.124695,356.774384 341.357788,358.575256 
	C341.855286,353.254181 342.310303,348.387329 342.824646,342.885803 
	C338.382324,341.914734 334.103821,340.719910 329.743652,340.093323 
	C324.532623,339.344482 326.423431,335.409210 326.372681,332.725861 
	C326.308105,329.311920 329.050232,330.197723 331.169891,330.559113 
	C335.086243,331.226776 339.002960,331.892334 343.647247,332.682587 
	C344.274689,324.836182 345.016968,317.310455 345.416901,309.766541 
	C345.600037,306.311920 346.315735,303.659790 350.381134,304.002502 
	C353.874603,304.296997 357.836548,303.826904 358.377869,309.277924 
	C359.150482,317.058014 360.578552,324.771088 361.475800,332.541748 
	C361.780823,335.183502 362.887146,336.297241 365.412659,336.639679 
	C369.369263,337.176178 373.298401,337.919922 377.233612,338.607788 
	C382.466736,339.522522 380.479706,343.661499 380.514740,346.598358 
	C380.558289,350.243378 377.614319,348.964935 375.695160,348.734009 
	C371.919373,348.279633 368.174988,347.564423 363.701202,346.841339 
	C364.392395,351.912201 364.841644,356.663513 365.822479,361.302429 
	C366.046295,362.360992 368.005188,363.526306 369.337708,363.798126 
	C376.671570,365.294128 384.034302,366.697327 391.439117,367.774933 
	C394.754272,368.257324 396.009583,369.639771 396.010681,372.937286 
	C396.015198,386.737610 397.068298,384.163574 385.022614,382.753815 
	C382.378845,382.444427 379.758118,381.942017 377.122864,381.555115 
	C374.654358,381.192657 372.180664,380.865479 368.662903,380.377716 
	C370.649628,392.817169 372.572479,404.856812 374.583435,417.321869 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M491.355225,589.648987 
	C492.870239,589.554749 494.214050,590.280151 495.364594,590.047913 
	C521.736328,584.726624 548.072205,579.226624 574.458923,573.981873 
	C578.051086,573.267883 577.389282,571.052612 577.387939,568.847107 
	C577.373535,544.749084 577.330383,520.651123 577.298218,496.553101 
	C577.296204,495.057892 577.321289,493.562592 577.445923,491.621338 
	C581.095154,490.437592 582.176880,492.008484 582.071594,495.419220 
	C582.006348,497.531921 582.790466,499.670868 583.692627,502.349091 
	C584.118530,506.934723 584.045288,510.969330 583.580994,515.103882 
	C582.995178,520.943787 582.787842,526.683411 582.663269,532.424866 
	C582.659363,532.605286 583.508606,532.804260 584.075928,533.448792 
	C584.126221,538.602295 584.060791,543.301514 583.602112,548.098633 
	C583.021912,555.283691 582.825256,562.370605 582.706177,569.458923 
	C582.703247,569.632751 583.563660,569.821106 584.147949,570.278076 
	C584.342651,570.949829 584.410706,571.346252 584.111511,571.842285 
	C583.265625,572.620178 582.786987,573.298279 582.308350,573.976379 
	C582.819153,574.222839 583.329956,574.469238 583.840820,574.715698 
	C584.231079,573.782593 584.621399,572.849487 585.389832,571.797424 
	C593.875488,569.882690 601.983093,568.086792 610.090637,566.290894 
	C632.145081,561.608154 654.199524,556.925354 677.008301,552.127197 
	C680.179749,551.224731 683.726013,552.368225 684.194580,548.249756 
	C684.800415,546.336670 685.923767,544.426147 685.933472,542.510010 
	C686.053894,518.711365 686.048706,494.911835 685.969666,471.112854 
	C685.958984,467.889923 686.124329,465.320770 690.827393,466.085175 
	C691.179382,466.550262 691.085022,466.978363 690.510498,467.833435 
	C688.760803,471.931274 687.564270,475.597412 690.733826,478.976929 
	C690.803223,484.021210 690.872620,489.065491 690.466919,494.694458 
	C689.659851,499.976959 689.234619,504.671692 689.081848,509.375275 
	C689.054260,510.223724 690.147461,511.108582 690.723206,511.976624 
	C690.814270,516.021301 690.905273,520.066040 690.528198,524.679382 
	C688.682434,528.603394 687.527405,531.943237 690.739990,534.977844 
	C690.807129,536.062622 690.874268,537.147461 690.489502,538.737915 
	C688.509583,541.686584 687.872498,544.030701 690.785828,545.980408 
	C690.749207,548.998108 692.381592,548.813416 694.670959,548.304016 
	C709.733215,544.952637 724.818115,541.702393 739.904968,538.462769 
	C762.130920,533.690125 784.360840,528.935669 806.602600,524.237549 
	C808.351990,523.868042 810.207153,523.999207 812.455200,523.844604 
	C814.013916,524.107849 815.130554,524.424255 816.604614,524.841980 
	C816.138916,525.922485 815.608582,527.152954 815.072510,528.675781 
	C800.642334,532.135376 786.227112,535.344788 771.791687,538.460449 
	C745.813538,544.067261 719.823242,549.618042 693.369507,554.797729 
	C691.833801,552.905334 690.766541,551.407471 689.290039,549.335388 
	C687.851929,551.464844 686.834106,552.971802 685.506348,554.937866 
	C688.164673,555.149658 690.041199,555.299194 691.917664,555.448730 
	C691.609070,557.956543 691.300476,560.464294 690.463867,563.573181 
	C689.694702,571.731995 689.431763,579.289307 689.278625,586.848816 
	C689.271240,587.215027 690.228638,587.600769 690.736816,587.977417 
	C690.804138,592.596436 690.871460,597.215393 690.424194,602.514282 
	C689.614563,603.945251 689.064758,604.695312 689.061951,605.447510 
	C689.001282,621.601685 688.969299,637.756348 689.067261,653.910034 
	C689.073486,654.936768 690.180908,655.956787 690.776001,656.979919 
	C690.853699,657.734558 690.931335,658.489197 690.993530,659.626282 
	C689.470459,660.174561 687.962830,660.340393 686.233826,659.783325 
	C686.011536,626.040283 686.010620,593.020142 685.992188,559.755493 
	C685.818115,559.254639 685.661621,558.998352 685.505066,558.742065 
	C685.352539,559.163818 685.200012,559.585571 684.826050,560.017090 
	C684.604553,560.026917 684.161377,560.016235 684.058472,559.647949 
	C683.299011,558.846130 682.642395,558.412659 681.985840,557.979126 
	C681.817444,557.977234 681.648987,557.975281 680.871094,558.036682 
	C677.838257,558.720947 675.414856,559.341858 672.991455,559.962769 
	C645.416870,565.800476 617.842285,571.638550 590.267395,577.474548 
	C589.131226,577.715027 587.991333,577.937988 586.084595,578.390381 
	C584.978638,579.821899 584.348328,581.031677 584.346863,582.242310 
	C584.312134,611.165344 584.325378,640.088501 584.435547,669.011292 
	C584.440063,670.188721 585.473206,671.362244 586.027100,672.537598 
	C583.518555,672.754639 581.010010,672.971619 578.132629,673.033936 
	C577.637817,649.036560 577.508118,625.193787 577.390503,601.351074 
	C577.375000,598.203918 577.421082,595.056458 577.745056,591.318237 
	C577.827087,587.827148 577.602722,584.927063 577.378296,582.026978 
	C575.966614,581.640381 574.441406,580.692200 573.160156,580.951111 
	C553.144165,584.996094 533.160461,589.201172 513.167419,593.359802 
	C506.015900,594.847351 498.859161,596.309814 491.309692,597.878418 
	C490.974396,595.322876 491.034210,592.672729 491.355225,589.648987 
z"/>
		<path fill="#053063" opacity="1.000000" stroke="none"
			d="
M868.960876,589.239136 
	C868.530151,589.436157 868.099365,589.633301 867.033997,589.593384 
	C863.620056,590.286926 860.840698,591.217407 858.061401,592.147888 
	C857.257019,592.422363 856.452576,592.696838 855.211609,592.804688 
	C854.542053,592.814514 854.309021,592.990967 854.076050,593.167480 
	C853.556335,593.401550 853.036621,593.635559 852.084167,593.659668 
	C851.091064,593.725708 850.530762,594.001709 849.970398,594.277649 
	C849.538147,594.475769 849.105957,594.673950 848.040405,594.621643 
	C840.961975,596.312134 834.516846,598.253174 828.071655,600.194214 
	C827.559265,600.428772 827.046936,600.663330 826.072266,600.497253 
	C825.398499,598.640015 825.005798,597.183716 825.002991,595.726685 
	C824.960938,574.160645 824.964783,552.594543 824.985718,531.028442 
	C824.986816,529.945374 825.242371,528.862488 825.297058,528.430725 
	C829.507019,528.192017 833.295166,527.977234 837.083313,527.762451 
	C837.523621,527.765564 837.963989,527.768738 838.924011,528.175903 
	C846.309631,529.605469 853.178162,530.614258 860.040894,531.660583 
	C869.353271,533.080505 878.633301,534.777283 887.986084,535.833435 
	C891.339661,536.212097 892.114563,537.342773 892.086670,540.392883 
	C891.969788,553.178772 892.111633,565.967407 891.942139,578.752075 
	C891.918762,580.513184 890.680359,582.258240 890.004456,584.010742 
	C889.200500,584.297424 888.396484,584.584106 886.984619,584.610840 
	C881.901733,585.662354 877.426636,586.973755 872.951599,588.285156 
	C872.520813,588.470581 872.090027,588.656006 871.160889,588.642944 
	C870.095398,588.709351 869.528137,588.974243 868.960876,589.239136 
z"/>
		<path fill="#053063" opacity="1.000000" stroke="none"
			d="
M1108.196533,837.119202 
	C1075.105225,853.007996 1040.795166,856.982483 1005.225891,850.481812 
	C994.956543,848.604980 984.850037,845.836975 974.325562,843.397949 
	C974.825073,842.388428 974.914368,841.909058 975.202759,841.667847 
	C991.085999,828.388245 1008.749146,818.906067 1029.663208,816.628357 
	C1040.087891,815.493042 1050.140869,817.349487 1060.074829,820.627319 
	C1070.450439,824.050781 1080.890381,827.414246 1091.510986,829.918945 
	C1101.093750,832.178833 1110.698120,830.273865 1120.066772,827.573181 
	C1120.840454,827.350159 1121.652588,827.256653 1122.451538,827.132874 
	C1122.541626,827.118896 1122.661865,827.299927 1123.548584,828.055542 
	C1118.366089,831.133240 1113.451904,834.051636 1108.196533,837.119202 
z"/>
		<path fill="#053063" opacity="1.000000" stroke="none"
			d="
M928.270996,539.884033 
	C941.045044,541.620117 953.378662,543.304260 965.895752,545.013367 
	C965.895752,552.580566 965.895752,559.858765 965.895752,567.680725 
	C944.426208,572.327026 922.904297,576.984680 901.071838,581.709534 
	C901.071838,566.557983 901.071838,551.659973 901.071838,536.173035 
	C910.173706,537.417664 919.002136,538.624878 928.270996,539.884033 
z"/>
		<path fill="#073164" opacity="1.000000" stroke="none"
			d="
M407.358154,436.772766 
	C408.068359,428.092896 411.944824,423.163025 418.935730,421.601013 
	C424.938232,420.259796 431.438324,423.240631 434.585602,428.777771 
	C437.671295,434.206573 437.032593,442.165436 431.856598,445.493378 
	C426.711853,448.801147 423.806610,452.288910 425.536560,458.855438 
	C422.572632,458.442657 420.331665,458.130585 417.812225,457.779694 
	C417.650024,456.846832 417.273560,455.897552 417.364960,454.995697 
	C417.748566,451.210754 416.480133,448.933594 413.088318,446.565155 
	C410.343231,444.648285 409.232880,440.390350 407.358154,436.772766 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M484.557312,603.135132 
	C484.104492,602.559875 484.028503,602.101624 484.075104,601.312866 
	C486.152252,601.257874 488.106812,601.533386 490.361389,601.887085 
	C490.727539,607.349121 490.793762,612.733093 490.410309,618.693359 
	C490.174713,621.503723 490.388763,623.737671 490.602844,625.971619 
	C490.687744,634.352783 490.772644,642.733948 490.384216,651.713074 
	C489.624146,657.979675 489.292664,663.646912 489.123779,669.319092 
	C489.107819,669.855103 490.113251,670.421570 490.644531,670.973877 
	C490.742035,674.687622 490.839539,678.401367 490.904419,682.578613 
	C487.150604,683.324341 485.300507,682.435730 486.356323,677.965942 
	C487.005585,675.217407 486.041504,672.120361 486.035431,669.179260 
	C485.993500,648.896118 486.038757,628.612732 485.966217,608.329712 
	C485.960144,606.635986 485.293793,604.944641 484.557312,603.135132 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M609.848022,565.980591 
	C601.983093,568.086792 593.875488,569.882690 585.279602,571.683472 
	C584.791260,571.688354 584.478821,571.742615 584.478821,571.742615 
	C584.410706,571.346252 584.342651,570.949829 584.251221,569.818970 
	C584.150391,562.056580 584.072876,555.028687 583.995361,548.000793 
	C584.060791,543.301514 584.126221,538.602295 584.167725,532.988953 
	C584.086487,526.384583 584.029236,520.694214 583.971924,515.003906 
	C584.045288,510.969330 584.118530,506.934723 584.080200,502.447876 
	C584.057556,499.345642 584.505127,496.647125 584.154785,494.056549 
	C583.573547,489.758453 585.209412,487.758545 589.414917,487.138824 
	C593.015686,486.608246 596.545654,485.597321 600.528687,484.828186 
	C598.002319,486.045593 595.088989,487.333069 592.093079,488.385162 
	C590.229004,489.039734 588.239746,489.338074 586.220581,489.816650 
	C586.220581,516.340881 586.220581,542.776978 586.220581,569.634583 
	C592.479004,568.303833 598.400269,566.971863 604.357117,565.824463 
	C606.053528,565.497620 607.853149,565.706787 609.848022,565.980591 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M682.002014,558.448792 
	C682.642395,558.412659 683.299011,558.846130 683.971008,560.108398 
	C683.985474,594.292358 683.984497,627.647522 683.983582,661.002747 
	C681.599243,661.349060 679.214905,661.695374 676.416626,661.976013 
	C682.351990,659.405884 682.133789,654.141052 682.103943,648.530518 
	C681.945007,618.660522 682.022522,588.789246 682.002014,558.448792 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M890.422852,584.041382 
	C890.680359,582.258240 891.918762,580.513184 891.942139,578.752075 
	C892.111633,565.967407 891.969788,553.178772 892.086670,540.392883 
	C892.114563,537.342773 891.339661,536.212097 887.986084,535.833435 
	C878.633301,534.777283 869.353271,533.080505 860.040894,531.660583 
	C853.178162,530.614258 846.309631,529.605469 839.229858,528.308105 
	C857.166504,530.342896 875.316956,532.649414 894.004395,535.024170 
	C894.004395,543.138916 894.012085,550.920227 894.002136,558.701477 
	C893.992981,565.865906 893.905579,573.030884 893.979248,580.194336 
	C894.003113,582.510498 893.638306,584.190552 890.422852,584.041382 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M684.120239,547.828125 
	C683.726013,552.368225 680.179749,551.224731 677.373169,551.966797 
	C683.242188,544.724182 682.155273,535.992371 682.016846,527.492004 
	C681.806274,514.556946 681.408875,501.624664 681.240784,488.689240 
	C681.142395,481.118195 681.335022,473.543335 681.209473,465.613373 
	C681.197144,465.146088 681.372131,465.035675 682.127686,464.801331 
	C683.131226,464.809601 683.554016,464.941803 683.976868,465.074036 
	C683.999939,492.518188 684.022949,519.962341 684.120239,547.828125 
z"/>
		<path fill="#FEFEFE" opacity="1.000000" stroke="none"
			d="
M684.244568,660.892395 
	C683.984497,627.647522 683.985474,594.292358 684.073914,560.476685 
	C684.161377,560.016235 684.604553,560.026917 685.066284,560.014404 
	C685.528076,560.001953 686.009766,560.000000 686.009766,560.000000 
	C686.010620,593.020142 686.011536,626.040283 686.012329,659.528687 
	C685.509949,660.258606 685.007751,660.520325 684.244568,660.892395 
z"/>
		<path fill="#042F62" opacity="1.000000" stroke="none"
			d="
M586.470581,672.464905 
	C585.473206,671.362244 584.440063,670.188721 584.435547,669.011292 
	C584.325378,640.088501 584.312134,611.165344 584.346863,582.242310 
	C584.348328,581.031677 584.978638,579.821899 585.706299,578.577637 
	C586.065002,580.463135 586.006348,582.382812 586.005981,584.302429 
	C586.000183,611.750122 585.997131,639.197754 586.018433,666.645447 
	C586.019470,667.929016 586.254456,669.212463 586.377441,670.464966 
	C589.952698,670.464966 593.199036,670.464966 596.458984,670.881104 
	C595.986389,671.556274 595.500183,671.815369 595.013916,672.074463 
	C592.313965,672.180420 589.614014,672.286316 586.470581,672.464905 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M836.767822,527.566284 
	C833.295166,527.977234 829.507019,528.192017 825.297058,528.430725 
	C825.242371,528.862488 824.986816,529.945374 824.985718,531.028442 
	C824.964783,552.594543 824.960938,574.160645 825.002991,595.726685 
	C825.005798,597.183716 825.398499,598.640015 825.782043,600.466187 
	C822.709045,602.618469 823.641235,599.847839 823.618286,598.547974 
	C823.471741,590.253296 823.381165,581.956909 823.362427,573.660889 
	C823.326904,557.925659 823.352112,542.190308 823.352112,525.681091 
	C828.061157,526.288208 832.256714,526.829163 836.767822,527.566284 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M397.244568,665.969849 
	C397.353180,671.037598 397.461823,676.105347 397.419739,681.623474 
	C395.213959,683.060791 393.158875,684.047729 390.755676,685.039551 
	C390.323578,680.988831 390.239563,676.933350 390.612213,672.412231 
	C392.293427,670.787292 393.526123,669.636475 394.739807,668.465942 
	C395.588165,667.647888 396.410553,666.802856 397.244568,665.969849 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M397.895020,694.635132 
	C401.320374,693.893738 404.749023,693.499023 408.602783,693.172852 
	C409.225708,696.670715 407.775848,697.667603 404.517426,696.538635 
	C403.635986,696.233276 402.267578,696.387512 401.492157,696.895142 
	C398.920990,698.578369 398.398071,696.913513 397.895020,694.635132 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M828.484863,600.196106 
	C834.516846,598.253174 840.961975,596.312134 847.676514,594.607910 
	C841.596558,596.629150 835.247314,598.413574 828.484863,600.196106 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M873.327942,588.306885 
	C877.426636,586.973755 881.901733,585.662354 886.660828,584.588379 
	C882.531372,585.993408 878.117798,587.161011 873.327942,588.306885 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M468.099854,602.113037 
	C467.275970,602.760620 466.458801,602.969360 465.289673,602.744995 
	C464.909424,600.318848 464.881134,598.325745 464.852875,596.332642 
	C465.971069,596.055298 467.089264,595.777954 468.552551,595.550903 
	C468.633942,597.625549 468.370270,599.649902 468.099854,602.113037 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M641.589111,474.993622 
	C637.848816,476.203094 633.695129,477.384583 629.274048,478.311340 
	C633.062988,477.026276 637.119324,475.995941 641.589111,474.993622 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M739.160278,655.355042 
	C740.752258,654.697449 742.497498,654.368713 744.629211,654.101562 
	C744.530518,655.388367 744.045288,656.613525 743.560059,657.838684 
	C742.144531,657.120422 740.729004,656.402161 739.160278,655.355042 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M479.272095,685.339478 
	C480.423859,684.730530 481.823029,684.370972 483.565491,683.923157 
	C483.650513,682.222046 483.736908,680.493164 483.954468,678.392700 
	C486.109039,684.051941 485.434906,685.169189 479.272095,685.339478 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M678.514954,465.780273 
	C675.822998,466.747314 672.721313,467.699036 669.338501,468.416077 
	C672.073303,467.375885 675.089233,466.570435 678.514954,465.780273 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M698.220398,660.303589 
	C699.665833,659.704834 701.325378,659.387512 703.289917,659.139648 
	C703.364441,660.358093 703.133972,661.507080 702.903442,662.656128 
	C701.413879,661.965759 699.924194,661.275391 698.220398,660.303589 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M858.463135,592.165039 
	C860.840698,591.217407 863.620056,590.286926 866.671082,589.587769 
	C864.250122,590.606750 861.557495,591.394531 858.463135,592.165039 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M595.058533,672.424194 
	C595.500183,671.815369 595.986389,671.556274 596.737549,671.169739 
	C597.454102,671.073120 597.905762,671.103882 598.691406,671.204590 
	C598.659973,672.420898 598.294556,673.567322 597.929199,674.713684 
	C596.987183,674.067078 596.045166,673.420471 595.058533,672.424194 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M617.711121,480.709229 
	C617.249695,484.347412 614.666809,482.764679 612.311707,482.391235 
	C613.818237,481.661896 615.590881,481.165985 617.711121,480.709229 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M511.130646,681.770996 
	C512.118042,681.276733 512.944275,681.140381 514.077637,681.079895 
	C513.760254,682.416443 513.135864,683.677063 512.511475,684.937622 
	C511.997437,684.001404 511.483459,683.065186 511.130646,681.770996 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M542.238037,678.330322 
	C543.137390,677.847473 544.248169,677.601868 545.699341,677.421021 
	C544.843018,677.846375 543.646240,678.206909 542.238037,678.330322 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M810.156494,606.292480 
	C810.783020,605.649597 811.563904,605.290894 812.671875,604.961121 
	C812.745361,605.835266 812.491760,606.680420 812.238220,607.525635 
	C811.595764,607.209290 810.953247,606.893005 810.156494,606.292480 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M396.993958,690.959351 
	C397.398224,691.723938 397.514130,692.516174 397.654480,693.713745 
	C394.884521,692.836548 394.747589,692.395935 396.993958,690.959351 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M462.198059,687.312988 
	C462.835205,686.882751 463.645630,686.675171 464.756714,686.573669 
	C464.162018,686.965027 463.266663,687.250366 462.198059,687.312988 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M814.058472,604.966064 
	C814.395264,604.454407 814.892944,604.220581 815.677002,603.985718 
	C816.089111,604.502930 816.214844,605.021118 816.340576,605.539307 
	C815.633545,605.440857 814.926453,605.342407 814.058472,604.966064 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M419.203430,692.334106 
	C419.840363,691.931824 420.648895,691.747070 421.758179,691.656860 
	C421.164307,692.018127 420.269653,692.284851 419.203430,692.334106 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M368.149109,698.291199 
	C368.535095,697.947876 369.044586,697.800171 369.803772,697.760620 
	C369.459839,698.074707 368.866241,698.280762 368.149109,698.291199 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M658.781372,470.609344 
	C658.474792,470.949615 657.904236,471.239319 657.187988,471.343567 
	C657.534058,470.958313 658.025696,470.758545 658.781372,470.609344 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M453.152466,688.297729 
	C453.536377,687.965393 454.044647,687.825928 454.802795,687.787109 
	C454.460754,688.088684 453.868774,688.289612 453.152466,688.297729 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M445.146851,689.274536 
	C445.530182,688.920349 446.039825,688.764404 446.802490,688.710815 
	C446.461395,689.033081 445.867249,689.252991 445.146851,689.274536 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M428.144958,691.267944 
	C428.529785,690.916931 429.040436,690.763672 429.803589,690.716187 
	C429.460968,691.036499 428.865906,691.251099 428.144958,691.267944 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M377.146729,697.281372 
	C377.531219,696.937927 378.040283,696.791565 378.801392,696.746216 
	C378.459381,697.057678 377.865356,697.268005 377.146729,697.281372 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M470.153015,686.300171 
	C470.537140,685.973450 471.045258,685.838562 471.802765,685.804077 
	C471.460449,686.100281 470.868744,686.296204 470.153015,686.300171 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M360.147949,699.281189 
	C360.531677,698.928772 361.040924,698.773804 361.802887,698.722900 
	C361.461548,699.044189 360.867493,699.261475 360.147949,699.281189 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M352.153564,700.293335 
	C352.533936,699.937500 353.041351,699.777283 353.802307,699.717163 
	C353.464142,700.041077 352.872375,700.265015 352.153564,700.293335 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M666.786133,468.649048 
	C666.477356,468.984619 665.907043,469.264008 665.194580,469.359497 
	C665.543152,468.981384 666.033875,468.787109 666.786133,468.649048 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M646.780396,473.648987 
	C646.471313,473.985870 645.901184,474.262299 645.189697,474.353882 
	C645.538696,473.975525 646.029053,473.782013 646.780396,473.648987 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M662.784607,469.624542 
	C662.475037,469.961914 661.902344,470.244690 661.185791,470.341553 
	C661.535095,469.960388 662.028320,469.765167 662.784607,469.624542 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M650.780701,472.659271 
	C650.472473,472.990112 649.902527,473.267242 649.190918,473.359802 
	C649.539124,472.985321 650.029053,472.795410 650.780701,472.659271 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M850.227722,594.321533 
	C850.530762,594.001709 851.091064,593.725708 851.791809,593.630737 
	C851.449829,593.996277 850.967468,594.180786 850.227722,594.321533 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M869.219299,589.288818 
	C869.528137,588.974243 870.095398,588.709351 870.802490,588.625488 
	C870.454102,588.983826 869.965881,589.161194 869.219299,589.288818 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M618.152832,669.291748 
	C618.534729,668.964966 619.041199,668.830078 619.795837,668.796387 
	C619.455200,669.092896 618.866333,669.288208 618.152832,669.291748 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M671.136047,663.228333 
	C671.517700,662.871765 672.027954,662.716980 672.792236,662.659973 
	C672.452332,662.981934 671.858521,663.206055 671.136047,663.228333 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M663.134583,664.233521 
	C663.518921,663.873474 664.029724,663.717285 664.793396,663.665466 
	C664.451172,663.992310 663.856140,664.214844 663.134583,664.233521 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M653.148193,665.276245 
	C653.531189,664.944397 654.039307,664.806396 654.795410,664.772827 
	C654.453369,665.074890 653.863342,665.272522 653.148193,665.276245 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M645.135254,666.236572 
	C645.521240,665.894470 646.032593,665.752747 646.794617,665.714539 
	C646.450378,666.024353 645.855469,666.230713 645.135254,666.236572 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M636.151550,667.283447 
	C636.532593,666.943665 637.039795,666.797852 637.796387,666.754639 
	C637.456360,667.063965 636.867065,667.270691 636.151550,667.283447 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M628.136292,668.234802 
	C628.519287,667.869446 629.029663,667.707275 629.793213,667.650940 
	C629.452087,667.983887 628.857910,668.210876 628.136292,668.234802 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M396.909973,685.004211 
	C397.275024,685.426025 397.416229,685.910095 397.347717,686.727783 
	C396.987396,686.396362 396.836761,685.731445 396.909973,685.004211 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M610.142090,670.259460 
	C610.527466,669.928223 611.036926,669.793579 611.795654,669.760620 
	C611.452026,670.060242 610.859131,670.258118 610.142090,670.259460 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M602.135742,671.234619 
	C602.519714,670.883606 603.030273,670.734558 603.794067,670.684326 
	C603.452332,671.000854 602.857300,671.218689 602.135742,671.234619 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M747.137512,654.237915 
	C747.521484,653.889404 748.032288,653.741760 748.795166,653.694702 
	C748.452881,654.009766 747.858643,654.224304 747.137512,654.237915 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M559.137329,676.245972 
	C559.523926,675.904053 560.034729,675.761841 560.795410,675.726440 
	C560.450684,676.037354 559.856140,676.241516 559.137329,676.245972 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M551.137207,677.238647 
	C551.520081,676.873413 552.030090,676.711548 552.794189,676.653320 
	C552.453552,676.985352 551.858948,677.213684 551.137207,677.238647 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M534.137207,679.245605 
	C534.522461,678.893372 535.032593,678.743225 535.794495,678.697388 
	C535.451538,679.017090 534.856812,679.232361 534.137207,679.245605 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M515.521667,681.337280 
	C516.003357,680.947205 516.750244,680.774048 517.770508,680.706787 
	C517.291504,681.059875 516.539185,681.307068 515.521667,681.337280 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M507.193359,682.295532 
	C507.574158,681.915588 508.124756,681.748413 508.864838,681.697327 
	C508.490601,682.045044 507.926880,682.276733 507.193359,682.295532 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M499.134521,683.233398 
	C499.518555,682.857727 500.029236,682.687256 500.792542,682.629272 
	C500.450531,682.974060 499.855865,683.206299 499.134521,683.233398 
z"/>
		<path fill="#EBEDF2" opacity="1.000000" stroke="none"
			d="
M683.898315,464.824371 
	C683.554016,464.941803 683.131226,464.809601 682.380371,464.620972 
	C682.641541,464.567993 683.230652,464.571381 683.898315,464.824371 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M625.717041,478.789429 
	C625.734497,479.004822 625.481750,479.185028 625.113281,479.214111 
	C625.147278,478.960052 625.296997,478.857147 625.717041,478.789429 
z"/>
		<path fill="#073064" opacity="1.000000" stroke="none"
			d="
M825.280518,907.820435 
	C825.270142,908.071106 825.291260,908.307861 825.312317,908.544617 
	C825.193359,908.359802 825.074341,908.174988 825.165833,907.886353 
	C825.376282,907.782471 825.311890,907.806519 825.280518,907.820435 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M621.662598,479.768005 
	C621.680298,479.986084 621.447388,480.161102 621.109619,480.182770 
	C621.140564,479.927917 621.276306,479.826416 621.662598,479.768005 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M854.328979,593.200867 
	C854.309021,592.990967 854.542053,592.814514 854.884888,592.786194 
	C854.857117,593.034302 854.719482,593.134277 854.328979,593.200867 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M956.223389,640.188721 
	C964.020020,640.250854 969.382568,643.619446 972.274902,650.392090 
	C974.993286,656.757690 974.023193,662.858704 969.428833,668.028503 
	C964.773621,673.266785 958.661072,674.613953 952.155518,672.549011 
	C945.825806,670.539917 941.737183,666.009766 940.965088,659.236633 
	C940.164246,652.212036 942.664368,646.434570 948.869019,642.750916 
	C950.951660,641.514404 953.485718,641.038330 956.223389,640.188721 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M1025.580078,685.526611 
	C1025.798584,684.916626 1026.231445,684.549316 1026.664185,684.181946 
	C1026.695679,684.748657 1026.727173,685.315369 1026.503052,686.056885 
	C1026.096313,686.077515 1025.945435,685.923340 1025.580078,685.526611 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M457.931763,604.655823 
	C438.288452,608.869446 418.645111,613.083069 398.511047,616.929321 
	C396.818146,615.704956 395.551422,614.922668 394.439240,613.961548 
	C393.817627,613.424377 393.452515,612.590393 392.971802,611.890137 
	C410.858337,607.914673 428.742218,603.927246 446.633423,599.972961 
	C450.668152,599.081238 454.728516,598.305481 459.307251,597.852722 
	C459.202209,600.371338 458.566986,602.513550 457.931763,604.655823 
z"/>
		<path fill="#F2F3F6" opacity="1.000000" stroke="none"
			d="
M381.627686,567.111267 
	C381.625946,570.689514 381.625946,573.799255 381.625946,577.579834 
	C377.125458,576.967163 373.131348,576.423401 368.927856,575.851196 
	C368.927856,570.160095 368.927856,564.755493 368.927856,558.694641 
	C373.028778,559.168457 377.018402,559.629395 381.629425,560.162170 
	C381.629425,562.470642 381.629425,564.556763 381.627686,567.111267 
z"/>
		<path fill="#F2F2F2" opacity="1.000000" stroke="none"
			d="
M333.079376,567.708740 
	C333.078857,563.106445 333.078857,558.966858 333.078857,554.174011 
	C337.583557,554.705627 341.601196,555.179810 345.876343,555.684326 
	C345.876343,561.537292 345.876343,567.099182 345.876343,573.270325 
	C342.448608,572.871338 339.231873,572.306152 335.997742,572.176819 
	C333.055542,572.059204 332.891266,570.347046 333.079376,567.708740 
z"/>
		<path fill="#F2F3F6" opacity="1.000000" stroke="none"
			d="
M409.691833,581.042480 
	C407.292786,580.806519 405.333984,580.614136 403.168976,580.401489 
	C403.168976,574.460876 403.168976,568.886414 403.168976,562.944641 
	C407.547577,563.549622 411.603729,564.110046 415.709717,564.677368 
	C415.709717,570.553223 415.709717,575.982361 415.709717,581.827881 
	C413.656250,581.554749 411.894165,581.320435 409.691833,581.042480 
z"/>
		<path fill="#F2F3F6" opacity="1.000000" stroke="none"
			d="
M449.852295,578.853638 
	C449.851166,581.126038 449.851166,582.937988 449.851166,585.504761 
	C445.527252,585.011414 441.508881,584.552856 437.337097,584.076843 
	C437.337097,578.294861 437.337097,572.872437 437.337097,567.134460 
	C441.534821,567.725525 445.443390,568.275879 449.853394,568.896851 
	C449.853394,572.186157 449.853394,575.289673 449.852295,578.853638 
z"/>
		<path fill="#F2F3F6" opacity="1.000000" stroke="none"
			d="
M238.135315,621.404419 
	C239.028427,619.674316 239.657806,617.722046 240.860077,617.259827 
	C243.595963,616.207947 246.613068,615.887634 249.822845,615.204590 
	C249.822845,621.248840 249.822845,626.997253 249.822845,633.098267 
	C246.101517,633.888977 242.415115,634.672302 238.131729,635.582397 
	C238.131729,630.676758 238.131729,626.267822 238.135315,621.404419 
z"/>
		<path fill="#F2F3F6" opacity="1.000000" stroke="none"
			d="
M238.334229,591.197266 
	C238.167511,585.507874 238.167511,580.223022 238.167511,574.631531 
	C242.056335,573.713257 245.724396,572.847107 249.766922,571.892578 
	C249.766922,577.758301 249.766922,583.319763 249.766922,589.563416 
	C246.164261,590.215271 242.332596,590.908508 238.334229,591.197266 
z"/>
		<path fill="#F2F3F6" opacity="1.000000" stroke="none"
			d="
M284.203247,619.858826 
	C284.204834,621.971191 284.204834,623.609924 284.204834,625.708923 
	C280.490295,626.548645 276.904358,627.359253 272.953125,628.252441 
	C272.953125,622.042236 272.953125,616.343018 272.953125,610.371704 
	C276.598816,609.543030 280.087860,608.749939 284.201630,607.814819 
	C284.201630,611.902771 284.201630,615.643921 284.203247,619.858826 
z"/>
		<path fill="#F2F3F6" opacity="1.000000" stroke="none"
			d="
M282.430725,582.195312 
	C279.120667,582.925232 276.235199,583.539856 272.692413,584.294556 
	C272.692413,578.802429 272.547729,573.848022 272.811066,568.915405 
	C272.865570,567.894409 274.264984,566.436584 275.342712,566.079285 
	C278.002167,565.197571 280.834686,564.837769 284.839020,564.012268 
	C284.140503,570.374451 283.497894,576.227295 282.430725,582.195312 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M397.370667,665.519287 
	C396.410553,666.802856 395.588165,667.647888 394.739807,668.465942 
	C393.526123,669.636475 392.293427,670.787292 390.719482,671.957520 
	C390.319153,664.632385 390.268188,657.296265 390.684448,649.494019 
	C393.238983,649.055725 395.107269,648.981995 395.105133,646.020630 
	C395.104645,645.371765 396.487122,644.721802 397.232697,644.072327 
	C397.320740,651.071106 397.408783,658.069885 397.370667,665.519287 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M397.385986,643.623901 
	C396.487122,644.721802 395.104645,645.371765 395.105133,646.020630 
	C395.107269,648.981995 393.238983,649.055725 390.766693,649.034912 
	C390.298126,642.657104 390.214539,636.272400 390.623596,629.431885 
	C393.145966,628.974182 395.175690,628.972351 397.205383,628.970581 
	C397.316681,633.705505 397.428009,638.440430 397.385986,643.623901 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M397.330017,628.531128 
	C395.175690,628.972351 393.145966,628.974182 390.730469,628.972656 
	C390.283722,624.355713 390.098419,619.738037 390.251953,615.131653 
	C390.288910,614.021912 391.448517,612.949524 392.531830,611.875000 
	C393.452515,612.590393 393.817627,613.424377 394.439240,613.961548 
	C395.551422,614.922668 396.818146,615.704956 398.090454,616.941284 
	C397.925323,620.910889 397.689972,624.501221 397.330017,628.531128 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M458.265564,604.667847 
	C458.566986,602.513550 459.202209,600.371338 459.722137,597.849365 
	C459.606842,597.469666 459.646820,597.471436 459.900116,597.564026 
	C460.436401,597.482971 460.719391,597.309326 461.002380,597.135742 
	C462.022552,596.878540 463.042725,596.621338 464.457886,596.348389 
	C464.881134,598.325745 464.909424,600.318848 464.973816,602.687622 
	C462.873108,603.602173 460.736267,604.141052 458.265564,604.667847 
z"/>
		<path fill="#E7EAF0" opacity="1.000000" stroke="none"
			d="
M460.764038,597.080322 
	C460.719391,597.309326 460.436401,597.482971 459.916229,597.552490 
	C459.887634,597.159973 460.169861,597.018860 460.764038,597.080322 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M690.860840,656.519409 
	C690.180908,655.956787 689.073486,654.936768 689.067261,653.910034 
	C688.969299,637.756348 689.001282,621.601685 689.061951,605.447510 
	C689.064758,604.695312 689.614563,603.945251 690.310730,602.939087 
	C690.789734,620.475647 690.867676,638.267273 690.860840,656.519409 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M690.823853,587.555908 
	C690.228638,587.600769 689.271240,587.215027 689.278625,586.848816 
	C689.431763,579.289307 689.694702,571.731995 690.346680,563.924133 
	C690.808533,571.494141 690.859680,579.314331 690.823853,587.555908 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M692.120850,555.489502 
	C690.041199,555.299194 688.164673,555.149658 685.506348,554.937866 
	C686.834106,552.971802 687.851929,551.464844 689.290039,549.335388 
	C690.766541,551.407471 691.833801,552.905334 692.958374,554.755920 
	C692.851440,555.357971 692.620911,555.498535 692.120850,555.489502 
z"/>
		<path fill="#F2F3F6" opacity="1.000000" stroke="none"
			d="
M320.381042,473.770264 
	C350.269196,478.362396 379.724731,482.879150 409.181427,487.388611 
	C415.106232,488.295593 421.014618,489.378418 426.970947,489.982117 
	C430.006226,490.289795 430.893524,491.442139 430.793274,494.359131 
	C430.600433,499.970001 430.737091,505.592194 430.737091,511.675049 
	C425.628204,511.044952 421.214478,510.500580 416.267883,509.890503 
	C416.267883,505.318115 416.267883,500.911774 416.267883,496.137787 
	C411.572266,495.446381 407.370300,494.827637 402.477905,494.107239 
	C402.477905,498.731812 402.477905,502.945404 402.477905,507.879181 
	C397.406036,507.174927 392.981598,506.805969 388.710114,505.792358 
	C387.661560,505.543518 386.522675,503.228394 386.428284,501.797089 
	C385.745850,491.447754 385.827606,491.440857 375.318207,490.182678 
	C374.660339,490.103943 373.996246,490.077271 372.727478,489.979584 
	C372.727478,494.311005 372.727478,498.563293 372.727478,503.567902 
	C367.190186,502.779022 362.341187,502.088226 357.053925,501.334991 
	C357.053925,496.617004 357.053925,492.196625 357.053925,487.267487 
	C352.300568,486.510101 347.933563,485.814240 342.965942,485.022705 
	C342.965942,489.753479 342.965942,494.164276 342.965942,499.305237 
	C337.476746,498.510559 332.633392,497.809387 327.321320,497.040375 
	C327.321320,492.356812 327.321320,487.922546 327.321320,482.902740 
	C322.428192,482.133026 317.936707,481.426483 313.658051,480.753448 
	C313.276154,481.305939 313.108490,481.437256 313.097290,481.580811 
	C312.765167,485.835480 313.951813,492.522339 311.817352,493.842224 
	C307.339722,496.611053 301.116791,496.557434 295.041962,497.776733 
	C292.660126,489.715698 290.373322,481.976257 288.005371,473.962158 
	C294.475525,471.723602 300.474030,469.801849 307.155579,471.554260 
	C311.320404,472.646606 315.677856,473.004669 320.381042,473.770264 
z"/>
		<path fill="#233867" opacity="1.000000" stroke="none"
			d="
M673.244751,560.220825 
	C675.414856,559.341858 677.838257,558.720947 680.640991,558.140991 
	C678.512939,558.947571 676.005432,559.713196 673.244751,560.220825 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M490.735718,670.515320 
	C490.113251,670.421570 489.107819,669.855103 489.123779,669.319092 
	C489.292664,663.646912 489.624146,657.979675 490.267151,652.170166 
	C490.691254,658.038513 490.759064,664.047607 490.735718,670.515320 
z"/>
		<path fill="#FEFEFE" opacity="1.000000" stroke="none"
			d="
M577.213196,582.448975 
	C577.602722,584.927063 577.827087,587.827148 577.702332,590.849426 
	C577.251465,588.271362 577.149780,585.571167 577.213196,582.448975 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M490.695160,625.545166 
	C490.388763,623.737671 490.174713,621.503723 490.292969,619.149536 
	C490.679352,621.059143 490.733398,623.088989 490.695160,625.545166 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M690.810730,511.517883 
	C690.147461,511.108582 689.054260,510.223724 689.081848,509.375275 
	C689.234619,504.671692 689.659851,499.976959 690.359131,495.151947 
	C690.783752,500.369537 690.841003,505.714325 690.810730,511.517883 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M690.824829,478.528381 
	C687.564270,475.597412 688.760803,471.931274 690.396118,468.141724 
	C690.813171,471.375336 690.864502,474.727570 690.824829,478.528381 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M690.828003,534.532837 
	C687.527405,531.943237 688.682434,528.603394 690.424438,525.134155 
	C690.831299,528.042847 690.873718,531.065308 690.828003,534.532837 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M690.866821,545.551025 
	C687.872498,544.030701 688.509583,541.686584 690.383179,539.134155 
	C690.801758,541.057007 690.874756,543.089294 690.866821,545.551025 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M583.602112,548.098633 
	C584.072876,555.028687 584.150391,562.056580 584.124634,569.543579 
	C583.563660,569.821106 582.703247,569.632751 582.706177,569.458923 
	C582.825256,562.370605 583.021912,555.283691 583.602112,548.098633 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M583.580933,515.103882 
	C584.029236,520.694214 584.086487,526.384583 584.052002,532.534729 
	C583.508606,532.804260 582.659363,532.605286 582.663269,532.424866 
	C582.787842,526.683411 582.995178,520.943787 583.580933,515.103882 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M584.111511,571.842285 
	C584.478821,571.742615 584.791260,571.688354 584.901489,571.802368 
	C584.621399,572.849487 584.231079,573.782593 583.840820,574.715698 
	C583.329956,574.469238 582.819153,574.222839 582.308350,573.976379 
	C582.786987,573.298279 583.265625,572.620178 584.111511,571.842285 
z"/>
		<path fill="#FDFDFD" opacity="1.000000" stroke="none"
			d="
M685.992188,559.755493 
	C686.009766,560.000000 685.528076,560.001953 685.287781,560.004639 
	C685.200012,559.585571 685.352539,559.163818 685.505066,558.742065 
	C685.661621,558.998352 685.818115,559.254639 685.992188,559.755493 
z"/>
	</svg>

);

export default LogoWhite;
